'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '@s7/styles';
import { getArrowPositionStyles } from './getArrowPositionStyles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const FloatingArrow = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { position = 'right', arrowSize = 6, arrowOffset = 0, arrowRadius = 3, arrowPosition = 'side', visible, arrowX = 0, arrowY = 0 } = _param, others = _object_without_properties_loose(_param, [
        "position",
        "arrowSize",
        "arrowOffset",
        "arrowRadius",
        "arrowPosition",
        "visible",
        "arrowX",
        "arrowY"
    ]);
    const theme = useTheme();
    if (!visible) {
        return null;
    }
    return /*#__PURE__*/ jsx("div", _extends({}, others, {
        ref: ref,
        style: getArrowPositionStyles({
            dir: theme.dir,
            position,
            arrowSize,
            arrowOffset,
            arrowRadius,
            arrowPosition,
            arrowX,
            arrowY
        })
    }));
});
FloatingArrow.displayName = 'FloatingArrow';

export { FloatingArrow };
//# sourceMappingURL=FloatingArrow.js.map
